import styles from './OurWorks.module.scss'

interface CaseList {
  src: string
  alt: string
  type1: string
  url1: string
  type2: string
  url2: string
  project: string
  corporate: string
  introduction: string
}

interface LogoList {
  src: string
  alt: string
}

const caseLists: CaseList[] = [
  {
    src: '/images/lp2/04_works/img_case_pja.png',
    alt: 'PEACH JOHN公式アプリ',
    type1: 'UX/UIデザイン',
    url1: '/services/uiuxdesign',
    type2: 'モバイルアプリ',
    url2: '/services/mobileapp',
    project: 'PEACH JOHN公式アプリ',
    corporate: '株式会社ピーチ・ジョン',
    introduction:
      'アプリのリニューアルに伴い、コンセプトの再定義、ユーザーメリットと効果を鑑みた機能の取捨選択のワークショップ。既存のブランドから今回のリニューアルで刷新したいイメージとなるようなトーン＆マナーを考慮したUIデザイン、アプリ開発、継続的なシステム改修・運用をサポートしています。',
  },
  {
    src: '/images/lp2/04_works/img_case_cpm.jpg',
    alt: '共済マイページ',
    type1: 'UX/UIデザイン',
    url1: '/services/uiuxdesign',
    type2: 'サイト改善ソリューション',
    url2: '/services/growthhack',
    project: '共済マイページ',
    corporate: '日本コープ共済生活協同組合連合会',
    introduction:
      '日本コープ共済生活共同組合連合会様の基本的価値にある「相互扶助や協同の精神を育む」という点を大切にして、すべての組合員（ユーザー）様が「継続して使いやすい」「使っていて安心する」を感じていただけるUIを意識して加入者様向けの「マイページ」全体の構築を行わせていただきました。',
  },
  {
    src: '/images/lp2/04_works/img_case_tsb.png',
    alt: '東京スター銀行アプリ',
    type1: 'UX/UIデザイン',
    url1: '/services/uiuxdesign',
    type2: 'サイト改善ソリューション',
    url2: '/services/growthhack',
    project: '東京スター銀行アプリ',
    corporate: '株式会社野村総合研究所',
    introduction:
      '機能一覧でみると差別化が難しい銀行口座アプリ。その一方で口座アプリは銀行が顧客ダイレクトに接点を持つことができる重要なデジタルサービスです。当社では、元々あった機能一覧を再考し、デザイン思考のアプローチでユーザーが使うアプリは何かを検討して、モック制作、ユーザー調査からコンセプトを再設計して、UIデザインを担当させていただきました。',
  },
]

const logoItems: LogoList[] = [
  { src: '/images/lp2/04_works/logo_docomo.png', alt: 'docomoロゴ' },
  { src: '/images/lp2/04_works/logo_peachjohn.png', alt: 'PEACH_JOHNロゴ' },
  { src: '/images/lp2/04_works/logo_seven.png', alt: 'SEVENロゴ' },
  { src: '/images/lp2/04_works/logo_aeon.png', alt: 'AEONロゴ' },
  { src: '/images/lp2/04_works/logo_nomura.png', alt: 'nomuraロゴ' },
  { src: '/images/lp2/04_works/logo_coop.png', alt: 'CO-OPロゴ' },
  { src: '/images/lp2/04_works/logo_kaneka.png', alt: 'KANEKAロゴ' },
  { src: '/images/lp2/04_works/logo_sompo.png', alt: 'sonpoロゴ' },
  { src: '/images/lp2/04_works/logo_ana.png', alt: 'ANAロゴ' },
  { src: '/images/lp2/04_works/logo_smbc.png', alt: 'SMBCロゴ' },
  { src: '/images/lp2/04_works/logo_disco.png', alt: 'DISCOロゴ' },
  { src: '/images/lp2/04_works/logo_hitachi.png', alt: 'HITACHIロゴ' },
]

const OurWorks: React.FC = () => {
  const caseList = caseLists.map(({ src, alt, type1, url1, type2, url2, project, corporate, introduction }) => (
    <li className={styles.li} key={src}>
      <img className={styles.caseImg} src={src} alt={alt} />
      <div className={styles.typeWrapper}>
        <a href={url1} className={styles.typeTag} target="_blank" rel="noopener">
          {type1}
        </a>
        <a href={url2} className={styles.typeTag} target="_blank" rel="noopener">
          {type2}
        </a>
      </div>
      <p className={styles.projectName}>{project}</p>
      <p className={styles.corporateName}>{corporate}</p>
      <p className={styles.introductionText}>{introduction}</p>
    </li>
  ))

  const list = logoItems.map(({ src, alt }) => (
    <div key={src} className={styles.logoBox}>
      <img className={styles.logoImg} src={src} alt={alt} />
    </div>
  ))

  return (
    <>
      <section className={styles.OurWorks} id="OurWorks">
        <div className={styles.top}>
          <div className={styles.textWrapper}>
            <p className={`${styles.redText} ${styles.introText}`}>
              <span className={styles.redBox}></span>Our Works
            </p>
            <h3 className={styles.h3}>
              私たちが手掛けたプロジェクトは
              <br />
              多くのユーザーに利用されています
            </h3>
          </div>
        </div>
        <ul className={styles.ul}>{caseList}</ul>
        <div className={styles.performance}>
          <h4 className={styles.h4}>
            今まで200社以上の企業様に
            <br />
            選ばれた実績
          </h4>
          <div className={styles.logoWrapper}>{list}</div>
        </div>
      </section>
    </>
  )
}

export default OurWorks
